export const labels = ['Discordo totalmente', 'Discordo', 'Não concordo nem discordo', 'Concordo', 'Concordo Totalmente'];
export const labelsShort = ['DT', 'D', 'NC', 'C', 'CT'];